import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Accessibility/accessibility__nl-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;
export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout },
  seo: {
    title: 'Toegankelijkheidsverklaring | Lemonade',
    metaTitle: 'Toegankelijkheidsverklaring | Lemonade',
    description: '',
    ogImage: sharedConfig['nl-NL'].seo.ogImage,
  },
  MDXContent: content as DocumentTypes,
};
